import React from "react";
import Slider from "react-slick";
import Image from "next/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaSearchPlus } from "react-icons/fa";

function CloseIcon(props) {
  return (
    <svg width="2rem" height="2rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6Z"
      ></path>
    </svg>
  );
}

export default function Carousel({ images }) {
  const [imageShowing, setImageShowing] = React.useState(0);
  const [imageSelected, setImageSelected] = React.useState(null);
  const [nav1, setNav1] = React.useState(null);
  const [nav2, setNav2] = React.useState(null);
  const [slider1, setSlider1] = React.useState(null);
  const [slider2, setSlider2] = React.useState(null);

  React.useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,

    fade: true,
    afterChange: (event) => {
      setImageShowing(event);
    },
    // dots: true,
    asNavFor: ".slider-nav",
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "10px",
  };

  const onFullScreen = () => {
    const image = images[imageShowing].urlImage;
    setImageSelected(image);
  };

  const escFunction = React.useCallback((event) => {
    if (event.key === "Escape") {
      setImageSelected(null);
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  return (
    <div
      className={
        imageSelected
          ? "fixed top-0 left-0 flex items-center flex-col h-screen w-screen z-50 bg-black bg-opacity-95 justify-center"
          : ``
      }
    >
      <div className={imageSelected ? "w-screen md:w-7/12" : "slide-wrapper"}>
        {imageSelected && (
          <div
            onClick={() => {
              setImageSelected(null);
            }}
            className={`absolute right-4 top-0 text-white`}
          >
            <CloseIcon />
          </div>
        )}
        <Slider
          {...settingsMain}
          asNavFor={nav2}
          ref={(slider) => setSlider1(slider)}
        >
          {images.map(({ urlImage, id }) => (
            <div key={id} className="slick-slide">
              {!imageSelected && (
                <button
                  onClick={onFullScreen}
                  className="absolute top-0.5 right-0.5 z-50 p-1 rounded-md"
                >
                  <FaSearchPlus className="text-white" size={24} />
                </button>
              )}
              <Image
                onClick={onFullScreen}
                layout="responsive"
                src={urlImage}
                width={640}
                height={480}
                alt="Image"
              />
            </div>
          ))}
        </Slider>
        <div className="thumbnail-slider-wrap">
          <Slider
            {...settingsThumbs}
            asNavFor={nav1}
            ref={(slider) => setSlider2(slider)}
          >
            {[...images].map(({ urlImage, id }, index) => (
              <div
                key={id}
                className={`slick-slide px-2 py-1 ${
                  index === imageShowing ? "border-2 border-brand-primary" : ""
                }`}
              >
                {/* {slider2} */}
                <Image
                  layout="responsive"
                  src={urlImage}
                  width={100}
                  height={100}
                  alt="Image"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
